import apiClient from "./axios"
import { downloadAndOpenFile } from "./pdfApi"

export const getVehicleLcDocumentGroups = async (params = {}) => {
  const { data } = await apiClient.get("/vehicle-lc-documents/groups", {
    params,
  })
  return data
}

export const getVehicleLcDocuments = async (params = {}) => {
  const { data } = await apiClient.get("/vehicle-lc-documents", { params })
  return data
}

export const getVehicleLcDocument = async id => {
  const { data } = await apiClient.get(`/vehicle-lc-documents/${id}`)
  return data
}

export const createVehicleLcDocument = async payload => {
  const { data } = await apiClient.post("/vehicle-lc-documents", payload)
  return data
}

export const createBulkVehicleLcDocuments = async payload => {
  const { data } = await apiClient.post("/vehicle-lc-documents/bulk", payload)
  return data
}

export const updateVehicleLcDocument = async ({ id, ...payload }) => {
  const { data } = await apiClient.patch(`/vehicle-lc-documents/${id}`, payload)
  return data
}

export const deleteVehicleLcDocument = async id => {
  const { data } = await apiClient.delete(`/vehicle-lc-documents/${id}`)
  return data
}

export const downloadVehicleLcDocumentAcknowledgementPdf = ({
  vehicleStockId,
  onStart,
  onEnd,
} = {}) =>
  downloadAndOpenFile({
    url: `/vehicle-lc-documents/${vehicleStockId}/acknowledgement-pdf`,
    mimeType: "application/pdf",
    onStart,
    onEnd,
  })
